
import { defineComponent, PropType } from 'vue';

import { useInsertDataStore } from '@/hooks/use_insert_data_store';
import { ContentPurchaseCountConfirmModel } from '@/models/content_purchase_count_confirm_model';

import BaseStyle from './BaseStyle.vue';

export default defineComponent({
  name: 'ContentPurchaseCountConfirm',
  components: {
    BaseStyle,
  },
  props: {

    /**
     * Model
     */
    model: {
      type: Object as PropType<ContentPurchaseCountConfirmModel>,
      default: undefined,
    },
  },
  setup() {
    const { purchaseItems } = useInsertDataStore();
    return {
      purchaseItems,
    };
  },
});
